<template>
  <div class="Dict">
    <el-dialog
      class="customDialog"
      :title="dialogTitle"
      :visible.sync="isShow"
      width="870px"
      @close="closeDialog"
      top="15vh"
      :close-on-click-modal = 'false'
      :close-on-press-escape = 'false'
    >
      <el-form :inline="true" :model="formInline" :rules="rules" ref="form" label-width="100px" class="demo-form-inline">
        <el-form-item label="字典名称：" prop="dictName">
          <el-input class="form-input-long" v-model="formInline.dictName" placeholder="请输入" :disabled="dialogType==='info'"></el-input>
        </el-form-item>
        <el-form-item label="字典类型：" prop="dictType">
          <el-input class="form-input-long" v-model="formInline.dictType" placeholder="请输入" :disabled="dialogType==='info'"></el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-select class="form-input-long" v-model="formInline.status" placeholder="请选择" :disabled="dialogType==='info'">
            <el-option label="正常" value="0"></el-option>
            <el-option label="禁用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            class="form-input-long"
            resize="none"
            :rows="4"
            maxlength="255"
            :show-word-limit="true"
            v-model="formInline.remark"
            type="textarea"
            placeholder="请输入"
            :disabled="dialogType==='info'">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" :loading="true" v-if="loading"></el-button>
        <el-button type="primary" @click="onSubmit" v-else>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addDict, editDict } from '@/api/system'
export default {
  name: 'Dict',
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  components: { },
  data () {
    return {
      isShow: false,
      loading: false,
      dialogTitle: '',
      dialogType: '',
      dialogRow: null,
      formInline: {
        dictName: '',
        dictType: '',
        status: '0',
        remark: ''
      },
      rules: {
        dictName: [
          { required: true, message: '请输入字典名称', trigger: 'blur' }
        ],
        dictType: [
          { required: true, message: '请输入字典类型', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择字典状态', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  methods: {
    // 参数为标题，类型和数据
    open (title, type, row) {
      this.dialogTitle = title
      this.dialogType = type
      this.dialogRow = row
      this.isShow = true
      if (type !== 'add') {
        this.getDetails()
      }
    },
    // 查询详情
    getDetails () {
      Object.keys(this.formInline).forEach(k => {
        this.formInline[k] = this.dialogRow[k]
      })
    },
    onSubmit () {
      if (this.dialogType === 'add') {
        this.add()
      }
      if (this.dialogType === 'edit') {
        this.edit()
      }
    },
    add () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          addDict(this.formInline).then((res) => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              this.$emit('refresh')
              this.cancel()
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
        }
      })
    },
    edit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          this.formInline.dictId = this.dialogRow.dictId
          editDict(this.formInline).then((res) => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              this.$emit('refresh')
              this.cancel()
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
        }
      })
    },
    cancel () {
      this.isShow = false
    },
    closeDialog () {
      this.$refs.form.resetFields()
      this.formInline = this.$options.data().formInline
      this.loading = false
    }
  },
  filters: {}
}
</script>

<style lang="scss">
  .Dict{
  }
</style>
